import React from 'react';
import AccountRoutes from './Account.routes';

export default () => <AccountRoutes/>